"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurriculumClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const curriculum_serializer_1 = require("../serializers/curriculum.serializer");
const grade_serializer_1 = require("../serializers/grade.serializer");
const item_set_serializer_1 = require("../serializers/item-set.serializer");
const lesson_serializer_1 = require("../serializers/lesson.serializer");
const module_serializer_1 = require("../serializers/module.serializer");
const topic_serializer_1 = require("../serializers/topic.serializer");
const sdk_constants_1 = require("../../../constants/sdk.constants");
class CurriculumClient {
    constructor(client, curriculumSerializer) {
        this.client = client;
        this.curriculumSerializer = curriculumSerializer;
    }
    static newInstance(options, retryOptions) {
        return new CurriculumClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new curriculum_serializer_1.CurriculumSerializer(new grade_serializer_1.GradeSerializer(new module_serializer_1.ModuleSerializer(new topic_serializer_1.TopicSerializer(), new lesson_serializer_1.LessonSerializer(new item_set_serializer_1.ItemSetSerializer())))));
    }
    async findByUser(userId, headers) {
        const response = await this.client.get(`${sdk_constants_1.AUTHORING_API_PREFIX}/curriculums.findByUser`, {
            headers,
        });
        return response.body.data.map((curriculum) => this.curriculumSerializer.serializeOne(curriculum));
    }
}
exports.CurriculumClient = CurriculumClient;
//# sourceMappingURL=curriculum.client.js.map